export const getSupportWidgetScript = (embedCode: string) =>
	embedCode
		?.replace(
			`<script src="https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.3.2/iframeResizer.min.js"></script>`,
			"",
		)
		.replace(
			`var iframe = document.getElementById('dt-donation-widget').contentWindow;`,
			`var iframe = document.getElementById('dt-donation-widget')?.contentWindow;
			if(!iframe) {return;}`,
		);

export const scrollToElement = (elementId: string) => {
	const ele = document.getElementById(elementId);
	if (ele)
		window.scrollTo({
			top: ele.offsetTop,
			left: ele.offsetLeft,
			behavior: "smooth",
		});
};
export const scrollIntoView = (elementId: string) => {
	const element = document.getElementById(elementId);
	if (element) {
		element.scrollIntoView({ behavior: "smooth" });
	}
};
